import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  search: {
    paddingTop: theme.spacing(1),
  },
}));

export { useStyles };
